<template>
    <div>

        <!-- YEAR TABS -->
        <ul class="nav nav-tabs"
            id="myTab"
            role="tablist">
            <li v-for="(year, index) in getYears"
                class="nav-item"
                role="presentation"
                :key="year">

                <button class="nav-link"
                    :class="index == 0 ? 'active': ''"
                    :id="getYearButtonId(year)"
                    data-bs-toggle="tab"
                    :data-bs-target="getTarget(year)"
                    type="button"
                    role="tab"
                    :aria-controls="getTabId(year)"
                    :aria-selected="index == 0">
                    {{year}}
                </button>
            </li>
        </ul>

        <!-- TAB CONTENT -->
        <div class="tab-content"
            id="priceTabContent">

            <div v-for="(year, index) in getYears"
                class="tab-pane fade"
                :class="index == 0 ? 'show active' : ''"
                :id="getTabId(year)"
                role="tabpanel"
                :aria-labelledby="getTabAreaLabel(year)"
                :key="year">

                <!-- RENT TABLE -->
                <table class="table pricelist-table rental table-hover">

                    <tbody>

                        <!-- DYNAMIC HEADER -->
                        <tr>
                            <td>&nbsp;</td>

                            <td v-for="range in nightRanges"
                                :key="range"
                                class="text-center">
                                {{ formatRange(range) }} {{ voMsg('tpl.text.nights') }}
                            </td>
                        </tr>

                        <!-- SEASONS -->
                        <tr v-for="season in seasonArray"
                            :key="season.fromdate"
                            class="subrow"
                            v-if="isDateInRange(season.fromdate, year)">

                            <td class="subinfo">
                                {{ getFormattedDate(season.fromdate) }} - {{ getFormattedDate(season.tilldate) }}
                                <br/>
                                <small>{{season.season}}</small>
                            </td>

                            <td v-for="range in nightRanges"
                                :key="range"
                                class="text-center">

                                {{ getCalculatedPrice(season[range]) }}

                            </td>

                        </tr>

                    </tbody>
                </table>


                <div class="rental-hint"><i class="fa-sharp fa-light fa-circle-info"
                        aria-hidden="true"></i> Alle Preise verstehen sich in Euro pro Nacht.</div>

                <!-- OTHER SERVICES -->
                <table class="table pricelist-table table-hover">

                    <tbody v-for="sg in priceArray"
                        v-if="sg.service.type != 'RENT' || (sg.service.type == 'RENT' && sg.service.surcharge)"
                        :key="sg.service._id">

                        <tr :class="{'mainrow': sg.lines && sg.lines.length > 0}">

                            <td>
                                {{sg.service.name}}

                                <small>

                                    <span v-if="sg.nightRange">

                                        <span v-if="sg.nightRange.max < 99">
                                            {{sg.nightRange.min}} - {{sg.nightRange.max}}
                                            {{voMsg('tpl.text.nights')}}
                                        </span>

                                        <span v-if="sg.nightRange.max > 99">
                                            {{voMsg('tpl.startfrom')}}
                                            {{sg.nightRange.min}}
                                            {{voMsg('tpl.text.nights')}}
                                        </span>
                                  
                                    </span>
                                  
                                    <span v-if="sg.guestRange">

                                        <span v-if="sg.guestRange.max > 99">
                                           {{voMsg('tpl.startfrom')}} {{sg.guestRange.min}} {{voMsg('tpl.text.persons')}}
                                         </span>
                                        <span v-if="sg.guestRange.max < 99">
                                          {{sg.guestRange.min}} - {{sg.guestRange.max}} {{voMsg('tpl.text.persons')}}
                                         </span>

                                      </span>

                                </small>

                                <span v-if="! sg.service.mandatory">
                                    ({{voMsg('tpl.text.optional')}})
                                </span>

                                <span v-if="sg.service.mandatory">
                                    <sup>*</sup>
                                </span>
                            </td>

                            <td class="text-end">

                                <span v-if="sg.service.calculation === 'FLAT'">
                                    {{voMsg('tpl.service.FLAT')}}
                                </span>

                                <span v-if="sg.service.calculation === 'NIGHT'">
                                    {{voMsg('tpl.service.NIGHT')}}
                                </span>

                                <span v-if="sg.service.calculation === 'WEEK'">
                                    {{voMsg('tpl.service.WEEK')}}
                                </span>

                                <span v-if="sg.service.calculation === 'MONTH'">
                                    {{voMsg('tpl.service.MONTH')}}
                                </span>

                            </td>

                            <td class="text-end price">
                                {{getCalculatedPrice(sg.price)}}
                            </td>

                        </tr>

                        <tr v-for="price in sg.lines"
                            class="subrow"
                            v-if="isDateInRange(price.fromdate,year)"
                            :key="price.sourceId">

                            <td class="subinfo">
                                {{ getFormattedDate(price.fromdate) }} - {{ getFormattedDate(price.tilldate) }}
                                <br/>
                                <small>{{price.season}}</small>
                            </td>

                            <td class="text-end calc">

                                <span v-if="price.calculation === 'FLAT'">
                                    {{voMsg('tpl.service.FLAT')}}
                                </span>

                                <span v-if="price.calculation === 'NIGHT'">
                                    {{voMsg('tpl.service.NIGHT')}}
                                </span>

                                <span v-if="price.calculation === 'WEEK'">
                                    {{voMsg('tpl.service.WEEK')}}
                                </span>

                                <span v-if="price.calculation === 'MONTH'">
                                    {{voMsg('tpl.service.MONTH')}}
                                </span>

                            </td>

                            <td class="text-end price">
                                {{getCalculatedPrice(price.value)}}
                            </td>

                        </tr>

                    </tbody>

                </table>

            </div>
        </div>

        <div class="hint"><i class="fa-sharp fa-light fa-circle-info"
                aria-hidden="true"></i>
            <sup>*</sup>{{voMsg('tpl.text.priceObligatory')}}
        </div>

    </div>
</template>

<script>
    import DateEx from 'voUtils/DateEx.js';

    export default {

    	voVueComponent: 'seasonprices2',

    	props: {
    		pricelist: String
    	},

    	data() {
    		return {
    			priceArray: [],
    			seasonArray: [],
    			nightRanges: []
    		};
    	},

    	mounted() {

    		const pricelist = JSON.parse(this.pricelist);
    		this.priceArray = pricelist

    		console.log('this.priceArray::' + JSON.stringify(this.priceArray, null, 2));

    		const fromDates = [];
    		const nightRangeSet = new Set();

    		for (let i = 0; i < pricelist.length; i++) {

    			if (pricelist[i].service.type !== 'RENT') continue;

    			for (let j = 0; j < pricelist[i].lines.length; j++) {

    				const line = pricelist[i].lines[j];

    				if (!line.fromdate || !line.nightRange) continue;

    				const fromdate = line.fromdate;
    				const rangeKey = `${line.nightRange.min}-${line.nightRange.max}`;

    				nightRangeSet.add(rangeKey);

    				if (!fromDates.includes(fromdate)) {

    					fromDates.push(fromdate);

    					const season = {
    						season: line.season,
    						fromdate: line.fromdate,
    						tilldate: line.tilldate
    					};

    					season[rangeKey] = line.value;

    					this.seasonArray.push(season);

    				} else {

    					const seasonIndex =
    						this.seasonArray.findIndex(
    							s => s.fromdate === fromdate
    						);

    					this.seasonArray[seasonIndex][rangeKey] = line.value;
    				}
    			}
    		}

    		this.nightRanges = Array.from(nightRangeSet)
    			.sort((a, b) =>
    				parseInt(a.split('-')[0]) -
    				parseInt(b.split('-')[0])
    			);
    	},

    	methods: {

    		formatRange(range) {

    				const [min, max] = range.split('-');

    				if (parseInt(max) > 90)
    					return `ab ${min}`;

    				//return `${min} - ${max}`;
    				return `bis ${max}`;
    			},

    			getYearButtonId(year) {
    				return 't' + year + '-tab';
    			},

    			getTarget(year) {
    				return "#t" + year;
    			},

    			getTabId(year) {
    				return "t" + year;
    			},

    			getTabAreaLabel(year) {
    				return "t" + year + "-tab";
    			},

    			getFormattedDate(date) {
    				return DateEx.formatDate(date, 'dd.MM.yy', 'de');
    			},

    			getCalculatedPrice(price) {

    				if (!price) return '';

    				return Number(price / 100)
    					.toLocaleString("de-DE", {
    						minimumFractionDigits: 2
    					}) + " €";
    			},

    			isDateInRange(fromdate, year) {
    				return parseInt(fromdate.substring(0, 4)) == year;
    			}

    	},

    	computed: {

    		getYears() {
    			const pricelist = JSON.parse(this.pricelist);
    			const years = [];
    			const currentYear = new Date().getFullYear();

    			for (let i = 0; i < pricelist.length; i++) {
    				for (let j = 0; j < pricelist[i].lines.length; j++) {
    					const line = pricelist[i].lines[j];
    					if (line.fromdate) {
    						const year = parseInt(line.fromdate.substring(0, 4), 10);

    						// nur aktuelle oder zukünftige Jahre
    						if (year >= currentYear && !years.includes(year)) {
    							years.push(year);
    						}
    					}
    				}
    			}

    			return years.sort((a, b) => a - b); // optional: Jahre sortieren
    		}
    	}
    };
</script>